const VIEWBOX_WIDTH = 340;
const VIEWBOX_HEIGHT = 564;
const CAPTION_X = 30;
const CAPTION_Y = 233;

interface EpcsSidePanelProps {
  artwork: string;
  caption: string;
}

/** Draws the caption in the artwork's own coordinate space, so it scales and crops with the image. */
const EpcsSidePanel = ({ artwork, caption }: EpcsSidePanelProps) => (
  <svg
    className="left-panel-image-desktop"
    viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}
    preserveAspectRatio="xMidYMid slice"
    role="img"
  >
    <title>{caption}</title>
    <image href={artwork} width={VIEWBOX_WIDTH} height={VIEWBOX_HEIGHT} />
    <foreignObject
      x={CAPTION_X}
      y={CAPTION_Y}
      width={VIEWBOX_WIDTH - 2 * CAPTION_X}
      height={VIEWBOX_HEIGHT - CAPTION_Y}
    >
      <p className="epcs-side-caption">{caption}</p>
    </foreignObject>
  </svg>
);

export default EpcsSidePanel;
